import { render, staticRenderFns } from "./CarPageContents.vue?vue&type=template&id=7df2d5fb&scoped=true&"
import script from "./CarPageContents.vue?vue&type=script&lang=js&"
export * from "./CarPageContents.vue?vue&type=script&lang=js&"
import style0 from "./CarPageContents.vue?vue&type=style&index=0&id=7df2d5fb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df2d5fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VMenu,VRow,VTextField})
